// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_menuAbsoluteBox__KO2i3 {
  position: absolute;
  box-sizing: border-box;

  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;



  /* background: #ffffff; */

  box-sizing: border-box;
  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.09);
  border-radius: 4px;
  /* left: -80px; */
  top: 90%;
  z-index: 3899;
  padding: 0 10px;
}

.styles_themeLeft__fj9Mh {
  left: -60px;
}

.styles_themeLeftLtr__x-jeK {
  left: 30px;
}

.styles_langLeft__LL9Gl {
  left: -30px;
}

.styles_themeLangLtr__KTQdN {
  left: 0px;
}

.styles_rtlLeft__F\\+ENO {
  left: -138px;
}

.styles_ltrRight__Qau3s {
  right: -138px;
}

.styles_setting__AzWrV {
  margin: 0 10px;
}

.styles_user__njGun {
  margin: 0 5px;
}

.styles_refreshIcon__BteOq {
  margin: 0 !important;
}

@media only screen and (max-width: 650px) {
  .styles_burger__lKnOT {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SettingPart/styles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;;EAEtB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;;;;EAIvB,yBAAyB;;EAEzB,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".menuAbsoluteBox {\n  position: absolute;\n  box-sizing: border-box;\n\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n\n\n\n  /* background: #ffffff; */\n\n  box-sizing: border-box;\n  box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.09);\n  border-radius: 4px;\n  /* left: -80px; */\n  top: 90%;\n  z-index: 3899;\n  padding: 0 10px;\n}\n\n.themeLeft {\n  left: -60px;\n}\n\n.themeLeftLtr {\n  left: 30px;\n}\n\n.langLeft {\n  left: -30px;\n}\n\n.themeLangLtr {\n  left: 0px;\n}\n\n.rtlLeft {\n  left: -138px;\n}\n\n.ltrRight {\n  right: -138px;\n}\n\n.setting {\n  margin: 0 10px;\n}\n\n.user {\n  margin: 0 5px;\n}\n\n.refreshIcon {\n  margin: 0 !important;\n}\n\n@media only screen and (max-width: 650px) {\n  .burger {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuAbsoluteBox": `styles_menuAbsoluteBox__KO2i3`,
	"themeLeft": `styles_themeLeft__fj9Mh`,
	"themeLeftLtr": `styles_themeLeftLtr__x-jeK`,
	"langLeft": `styles_langLeft__LL9Gl`,
	"themeLangLtr": `styles_themeLangLtr__KTQdN`,
	"rtlLeft": `styles_rtlLeft__F+ENO`,
	"ltrRight": `styles_ltrRight__Qau3s`,
	"setting": `styles_setting__AzWrV`,
	"user": `styles_user__njGun`,
	"refreshIcon": `styles_refreshIcon__BteOq`,
	"burger": `styles_burger__lKnOT`
};
export default ___CSS_LOADER_EXPORT___;
